<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="register-page" class="h-screen flex w-full" style="background-color: #262d4a">
    <div class="vx-col xs:w-5/6 sm:w-3/4 md:w-3/4 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card card-background="#11193f" class="glow-effect_white">
        <div class="vx-row">
          <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-2/5 mx-auto self-center">
            <img src="@/assets/images/register-icon-transparent.png" alt="login" class="mx-auto school-primary_gradient" />
          </div>
          <div class="vx-col sm:w-full md:w-full lg:w-3/5 mx-auto self-center">

            <div v-show="!registerSuccess">
              <h1 style="font-weight: 600; font-family: Montserrat;text-align: center;" class="mb-10 mt-1 text__school-font-color">Student Registration</h1>

              <div class="vx-row">
                <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/2">
                  <vx-input-group class="mb-4">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="UserIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-input
                      id="name_input"
                      autocomplete="off"
                      onClick="this.select();"
                      placeholder="Name"
                      v-validate="'required|alpha_spaces'"
                      name="name"
                      v-model="studentData.userFirstName"
                      class="w-full no-icon-border theme-dark digi_input"
                      size="large"
                    />
                  </vx-input-group>
                </div>
                <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/2">
                  <vx-input-group class="mb-4">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="UserIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-input
                      id="surname_input"
                      autocomplete="off"
                      onClick="this.select();"
                      placeholder="Surname"
                      v-model="studentData.userLastName"
                      v-validate="'required|alpha_spaces'"
                      name="surname"
                      class="w-full no-icon-border theme-dark digi_input"
                      size="large"
                    />
                  </vx-input-group>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col w-full">
                  <vx-input-group class="mb-4">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="AtSignIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-input
                      id="email_input"
                      autocomplete="off"
                      onClick="this.select();"
                      placeholder="Email"
                      v-validate="'required|email'"
                      name="email"
                      v-model="studentData.email"
                      class="w-full no-icon-border theme-dark digi_input"
                      size="large"
                    />
                  </vx-input-group>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/2">
                  <vx-input-group class="mb-4">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="LockIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <div style="display: flex;">
                      <vs-input
                        id="password_input"
                        autocomplete="off"
                        onClick="this.select();"
                        type="password"
                        placeholder="Password"
                        v-validate="'required|min:8|max:100'"
                        name="password"
                        ref="password"
                        class="w-full no-icon-border theme-dark digi_input"
                        v-model="studentData.password"
                        size="large"
                      />
                      <feather-icon v-show="studentData.password" v-if="!passwordToggled" @click="togglePassword('password_input')" icon="EyeIcon" class="cursor-pointer ml-2 text__school-tertiary-color"></feather-icon>
                      <feather-icon v-else @click="togglePassword('password_input')" icon="EyeOffIcon" class="cursor-pointer ml-2 text__school-tertiary-color"></feather-icon>
                    </div>
                  </vx-input-group>
                </div>
                <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/2">
                  <vx-input-group class="mb-4">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="LockIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <div style="display: flex;">
                      <vs-input
                        :disabled="!studentData.password"
                        id="conf_password_input"
                        autocomplete="off"
                        onClick="this.select();"
                        type="password"
                        placeholder="Confirm Password"
                        v-validate="'confirmed:password'"
                        name="confirm_password"
                        data-vv-as="password"
                        class="w-full no-icon-border theme-dark digi_input"
                        v-model="passwordConfirm"
                        size="large"
                      />
                      <feather-icon v-show="passwordConfirm" v-if="!confPasswordToggled" @click="togglePassword('conf_password_input')" icon="EyeIcon" class="cursor-pointer ml-2 text__school-tertiary-color"></feather-icon>
                      <feather-icon v-else @click="togglePassword('conf_password_input')" icon="EyeOffIcon" class="cursor-pointer ml-2 text__school-tertiary-color"></feather-icon>
                    </div>
                  </vx-input-group>
                </div>
              </div>

              <div v-if="$store.state.schoolTheme != 'swales' && $store.state.schoolTheme != 'ligbron'" class="vx-row">
                <div class="vx-col w-full">
                  <vx-input-group style="height: 50px;">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="BriefcaseIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <v-select
                      ref="schoolDropdown"
                      class="w-full style-chooser"
                      placeholder="Select a School"
                      :options="schools"
                      v-model="schoolDropdown"
                    />
                  </vx-input-group>
                </div>
              </div>


              <div class="mt-4 mb-3" style="text-align: center;">
                <vs-button :disabled="isRegisterDisabled" style="border-radius:24px" ref="register" size="large" class="mt-2 vs-con-loading__container school-primary_gradient glow-effect_tertiary" @click="register">
                  <img style="float:left; margin-left:-7px; margin-right:10px; margin-top:-2px; height:26px" src="https://lateralscaffolding.blob.core.windows.net/resources/icon-login-hover.png"/>
                  <strong>Register</strong>
                </vs-button>
              </div>
            </div>

            <div v-show="registerSuccess">
              <p class="text__school-font-color text-center" style="font-size:32px">You have registered successfully!</p>
              <div style="text-align: center;" class="mt-3">
                <vs-button style="border-radius:24px;" ref="register" size="large" class="mt-2 vs-con-loading__container school-primary_gradient glow-effect_tertiary" @click="goToLogin">
                  <img style="float:left; margin-left:-7px; margin-right:10px; margin-top:-2px; height:26px" src="https://lateralscaffolding.blob.core.windows.net/resources/icon-login-hover.png"/>
                  <strong>Go to Login</strong>
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </vx-card>

      <div style="text-align: center;" class="mt-4"><span style="color: lightgray">COPYRIGHT @ {{ new Date().getFullYear() }} <a style="color: #52b75d" >DigiCampus v2.0</a> | Powered by DigiCentral.co.za</span></div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data() {
    return {
      studentData: {
        siteId: 0,
        userFirstName: "",
        userLastName: "",
        email: "",
        password: "",
        schoolId: null
      },
      passwordConfirm: "",
      passwordToggled: false,
      confPasswordToggled: false,
      registerSuccess: false,
      busyRegistering: false,
      schoolDropdown: 0,
      schools: []
    };
  },
  computed: {
    isRegisterDisabled: function() {
      return this.busyRegistering || !(this.studentData.userFirstName && this.studentData.userLastName && this.studentData.email && this.passwordConfirm);
      // return this.busyRegistering || (!(this.studentData.userFirstName && this.studentData.userLastName && this.studentData.email && this.passwordConfirm) && (this.$store.state.schoolTheme != "swales" && !this.schoolDropdown && !this.schoolDropdown.value));
      // return this.busyRegistering || !(this.studentData.userFirstName && this.studentData.userLastName && this.studentData.email && this.passwordConfirm && this.schoolDropdown && this.schoolDropdown.value);
    }
  },
  mounted() {
    var self = this;
    self.$store.dispatch("updateTheme", "dark");
    if (self.$store.state.schoolTheme != "swales" && self.$store.state.schoolTheme != "ligbron") {
      self.getSchools();
    }
  },
  created() {
    document.title = "DigiCampus | Register";
  },
  methods: {
    register() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          if (self.$store.state.schoolTheme != "swales" && self.$store.state.schoolTheme != "ligbron" && !self.schoolDropdown && !self.schoolDropdown.value) {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              time: 5500,
              text: "A school is required",
              position:'bottom-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
            return;
          }
          self.busyRegistering = true;
          self.showLoadingOnElement("register", 0.75, "material");

          self.studentData.siteId = self.$route.query.siteid;
          self.studentData.schoolId = self.schoolDropdown ? parseInt(self.schoolDropdown.value) : null;

          var onSuccess = response => {
            self.registerSuccess = true;
          };
          var onFinally = function () {
            self.busyRegistering = false;
            self.$vs.loading.close(self.$refs.register.$el);
          };

          self.$ajaxPostAnon(self, "user/AddStudent", self.studentData, onSuccess, onFinally);
        } else {
          self.$validator.errors.items.forEach(function(error) {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              time: 5500,
              text: error.msg,
              position:'bottom-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          })

        }
      })
    },
    togglePassword(elementId) {
      if (document.getElementById(elementId).getAttribute('type')) {
        document.getElementById(elementId).removeAttribute("type");
        if (elementId == "password_input") {
          this.passwordToggled = true;
        }
        else {
          this.confPasswordToggled = true;
        }
      }
      else {
        document.getElementById(elementId).setAttribute("type", "password");
        if (elementId == "password_input") {
          this.passwordToggled = false;
        }
        else {
          this.confPasswordToggled = false;
        }
      }
    },
    getSchools() {
      var self = this;

      var onSuccess = response => {
        self.schools = response.data.map((item) => {return {label: item.text, value: item.value} });
      };

      self.$ajaxGetAnon(self, "Company/GetSchools/" + self.$route.query.siteid, onSuccess);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    goToLogin() {
      this.$router.push({ name: 'DigiLogin' });
    }
  }
};
</script>
<style lang="scss">
  @import "../assets/main-digi.scss";

  .dropdown-toggle {
    height: 50px !important;
  }

  .theme-dark .style-chooser .dropdown-toggle {
    border: 1px solid rgba(var(--vs-primary), .2) !important;
    background-color: #262c49 !important;
    border-radius: 0 7px 7px 0 !important;
  }
</style>
